import React from 'react'
import { connect } from 'react-redux'
import { Box, Grid, Button } from '@material-ui/core'
import { cancel, save } from '../actions/main'
import { setSettings, selectTab } from '../actions/settings'
import AddFormButton from '../containers/AddFormButton'
import CancelFormButton from '../containers/CancelFormButton'
import EmazeForm from '../containers/EmazeForm'
import { viewStyles, buttonStyles } from '../styles/styles'
import { browserHistory } from 'react-router'
import LZString from 'lz-string'

const RightPreviewPart = ({ cancel, settings, design, main, saveChanges, setSettings, selectTab, isShowPreview = true }) => {
    const classes = viewStyles()
    const buttonStyle = buttonStyles()
    
    const handleCancel = () => {
        if (settings.fromEditor) {
            // then we want to CLOSE the form editor, instead of going "back" to the form manager
            let data = {
                type: "close_form",
            }
            window.parent.postMessage(JSON.stringify(data), "*")
        }

        cancel();
        if(main.selectedForm != null){
            let config = JSON.parse(LZString.decompressFromBase64(main.selectedForm.Config));
            setSettings(main.selectedForm, config)
        }        
        browserHistory.push("/settings")
    }

    const handleSaveNextBtn = (settings, design) => {
        if (settings.showAddForm) {
            // when having the add form button, the next/save is always save
            saveChanges(settings, design);
        }
        else {
            switch (settings.tab.name) {
                case "templates":
                    selectTab(2);
                    break;
                case "edit":
                    selectTab(3);
                    break;
                case "design":
                    selectTab(4);
                    break;
                case "settings":
                default:
                    saveChanges(settings, design)
                    break;
            }
        }

    }

    let saveBtnName = "save";
    if (!settings.showAddForm) {
        // when having the add form button, the next/save is always save
        switch (settings.tab.name) {
            case "templates":
            case "edit":
            case "design":
                //case "settings":
                saveBtnName = "next";
                break;
            default:
                saveBtnName = "save";
                break;
        }
    }
    
    return (
        <Box>
            {
                isShowPreview ?
                    <div>
                        <Box m="5px 0 5px 30px">
                            <Box className={classes.titleRight}>Preview</Box>
                        </Box>
                        <Box m="5px 0 5px 30px" className={classes.rightDescription}>
                            {settings.description}
                        </Box>            
                        <Box m="5px 0 5px 30px" className={classes.previewBox}>
                            <EmazeForm isPreview={true}></EmazeForm>
                        </Box>
                    </div>                    
                    :
                    <></>
            }
            
            <Box className={classes.bottomBox} m="5px 0 5px 30px">
                <Grid container justifyContent="flex-end">
                    <Grid item xs={5}>
                        {
                            settings.showAddForm && !settings.fromEditor ?

                                <AddFormButton handleSave={() => saveChanges(settings, design, true)}></AddFormButton>
                                :
                                <></>
                        }
                    </Grid>
                    <Grid item xs={4}>
                        <Button className={buttonStyle.save} onClick={() => handleSaveNextBtn(settings, design)}>
                            {saveBtnName}
                        </Button>
                    </Grid>
                    
                </Grid>
            </Box>                                  
        </Box>
    )
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    cancel: (currentView) => dispatch(cancel(currentView)),
    saveChanges: (settings, design, addForm = false) => dispatch(save(settings, design, addForm)),
    setSettings: (form, config) => dispatch(setSettings(form, config)),
    selectTab: (id) => dispatch(selectTab(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(RightPreviewPart)